var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavingsBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6115 5.76094C13.3448 5.49427 13.2115 5.16094 13.2115 4.8276C13.2115 4.09427 12.8781 3.4276 12.4115 2.96094C11.9448 2.49427 11.2781 2.16094 10.5448 2.16094C10.2115 2.16094 9.87813 2.0276 9.61146 1.76094C8.61146 0.694271 6.87813 0.694271 5.81146 1.76094C5.61146 2.0276 5.27813 2.16094 4.94479 2.16094C3.47813 2.16094 2.27813 3.36094 2.27813 4.8276C2.27813 5.16094 2.14479 5.49427 1.87813 5.76094C0.811458 6.76094 0.811458 8.49427 1.87813 9.49427C2.14479 9.76094 2.27813 10.0943 2.27813 10.4276C2.27813 11.1609 2.61146 11.8276 3.07813 12.2943C3.54479 12.7609 4.21146 13.0943 4.94479 13.0943C5.27813 13.0943 5.61146 13.2276 5.87813 13.4943C6.41146 14.0276 7.07813 14.2943 7.74479 14.2943C8.41146 14.2943 9.07813 14.0276 9.61146 13.4943C9.87813 13.2276 10.2115 13.0943 10.5448 13.0943C12.0115 13.0943 13.2115 11.8943 13.2115 10.4276C13.2115 10.0943 13.3448 9.76094 13.5448 9.49427C14.6781 8.49427 14.6781 6.76094 13.6115 5.76094Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91667 9.96224C9.28486 9.96224 9.58333 9.66376 9.58333 9.29557C9.58333 8.92738 9.28486 8.62891 8.91667 8.62891C8.54848 8.62891 8.25 8.92738 8.25 9.29557C8.25 9.66376 8.54848 9.96224 8.91667 9.96224Z",
    fill: "url(#paint0_linear_85326_172965)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24479 7.29427C6.61298 7.29427 6.91146 6.99579 6.91146 6.6276C6.91146 6.25941 6.61298 5.96094 6.24479 5.96094C5.8766 5.96094 5.57812 6.25941 5.57812 6.6276C5.57812 6.99579 5.8766 7.29427 6.24479 7.29427Z",
    fill: "url(#paint1_linear_85326_172965)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24479 9.96094C6.04479 9.96094 5.91146 9.89427 5.77813 9.76094C5.51146 9.49427 5.51146 9.09427 5.77813 8.8276L8.44479 6.16094C8.71146 5.89427 9.11146 5.89427 9.37812 6.16094C9.64479 6.4276 9.64479 6.8276 9.37812 7.09427L6.71146 9.76094C6.57812 9.89427 6.44479 9.96094 6.24479 9.96094Z",
    fill: "url(#paint2_linear_85326_172965)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.4396 9.82682C13.1729 10.0935 13.0396 10.4268 13.0396 10.7602C13.0396 12.2268 11.8396 13.4268 10.3729 13.4268C10.0396 13.4268 9.70625 13.5602 9.43958 13.8268C8.90625 14.3602 8.23958 14.6268 7.57292 14.6268C6.90625 14.6268 6.23958 14.3602 5.70625 13.8268C5.43958 13.5602 5.10625 13.4268 4.77292 13.4268C4.03958 13.4268 3.37292 13.0935 2.90625 12.6268L5.83958 9.69349L9.43958 6.09349L12.3729 3.16016C12.8396 3.62682 13.1729 4.29349 13.1729 5.02682C13.1729 5.36016 13.3062 5.69349 13.5729 5.96016C14.5062 7.09349 14.5062 8.82682 13.4396 9.82682Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_85326_172965",
    x1: 8.91667,
    y1: 8.62891,
    x2: 8.91667,
    y2: 9.96224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF857A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF626F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_85326_172965",
    x1: 6.24479,
    y1: 5.96094,
    x2: 6.24479,
    y2: 7.29427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF857A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF626F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_85326_172965",
    x1: 7.57812,
    y1: 5.96094,
    x2: 7.57812,
    y2: 9.96094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF857A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF626F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingsBadge);
export default __webpack_public_path__ + "static/media/SavingsBadge.d1ed4a53417c43001920b862e18d23b3.svg";
export { ForwardRef as ReactComponent };